import axios from "axios";
export default {
  namespaced: true,
  state: {
    employee_benefits: [],
  },
  getters: {
    employee_benefits(state) {
      return state.employee_benefits;
    },
  },
  mutations: {
    SET_EMPLOYEE_BENEFITS(state, employee_benefits) {
      state.employee_benefits = employee_benefits;
    },
    ADD_EMPLOYEE_BENEFIT(state, employee_benefit) {
      state.employee_benefits.unshift(employee_benefit);
    },
    EDIT_EMPLOYEE_BENEFIT(state, employee_benefit) {
      var index = state.employee_benefits.findIndex(
        (a) => a.id == employee_benefit.id
      );
      state.employee_benefits.splice(index, 1, employee_benefit);
    },
    DELETE_EMPLOYEE_BENEFIT(state, employee_benefit) {
      let filtered = state.employee_benefits.filter((c) => {
        return c.id != employee_benefit.id;
      });
      state.employee_benefits = filtered;
    },
  },
  actions: {
    // get employee_benefits
    async get_employee_benefits({ commit }) {
      let response = await axios.get("/employee_benefits");
      commit("SET_EMPLOYEE_BENEFITS", response.data);
    },
    async add_employee_benefit({ commit }, request) {
      let response = await axios.post("/employee_benefit", request);
      commit("ADD_EMPLOYEE_BENEFIT", response.data);
    },
    async edit_employee_benefit({ commit }, request) {
      let response = await axios.put("/employee_benefit", request);
      commit("EDIT_EMPLOYEE_BENEFIT", response.data);
    },
    async delete_employee_benefit({ commit }, request) {
      await axios.delete("/employee_benefit/" + request.id);
      commit("DELETE_EMPLOYEE_BENEFIT", request);
    },
  },
};
